module.exports = __webpack_public_path__ + "static/media/stars-less-2732.b6681da1.jpg";